import { z } from "zod";

export const registerValidation = z.object({
  name: z.string().min(1, "Nama wajib diisi"),
  phone: z.string().min(1, "Nomor telepon wajib diisi"),
  email: z.string().email("Email tidak valid"),
  roleId: z.number().min(1, "Role wajib diisi"),
  password: z.string().min(6, "Password minimal 6 karakter"),
  isTermsAndConditions: z.boolean(),
});

export type RegisterPayload = z.infer<typeof registerValidation>;
